import type { StageSnapshot } from "@msc/shared";

import { AgendaItemSlide } from "./AgendaItemSlide.js";
import { AgendaSlide } from "./AgendaSlide.js";
import { EndSlide } from "./EndSlide.js";
import { PauseSlide } from "./PauseSlide.js";
import { TicketSlide } from "./TicketSlide.js";

/**
 * Wählt die Folie zum Modus des Snapshots — die einzige Verzweigung der
 * Bühne. Alles, was hier gerendert wird, stammt ausschließlich aus dem
 * Snapshot; die Bühne fragt nichts nach und hält keinen eigenen Zustand.
 */
export function StageSlides({ snapshot }: { snapshot: StageSnapshot }) {
  switch (snapshot.mode) {
    case "agenda":
      return <AgendaSlide snapshot={snapshot} />;
    case "agendaItem":
      return <AgendaItemSlide snapshot={snapshot} />;
    case "ticket":
      return <TicketSlide snapshot={snapshot} />;
    case "pause":
      return <PauseSlide branding={snapshot.branding} />;
    case "end":
      return <EndSlide snapshot={snapshot} />;
    default:
      return <PauseSlide branding={snapshot.branding} />;
  }
}
